import { render } from "./Card.vue?vue&type=template&id=88f5d62e"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "88f5d62e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('88f5d62e', __exports__)) {
    api.reload('88f5d62e', __exports__)
  }
  
  module.hot.accept("./Card.vue?vue&type=template&id=88f5d62e", () => {
    api.rerender('88f5d62e', render)
  })

}


export default __exports__